// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/util/vant'

import '@/assets/css/base.css'
import '@/assets/css/media.scss'
// import 'vant/lib/index.css'

import MetaInfo from 'vue-meta-info'
import {post, fetch, patch, put, downLoad} from './util/api'
import VueClipboard from 'vue-clipboard2'
import 'lib-flexible/flexible'
import VueWechatTitle from 'vue-wechat-title'

// import VConsole from 'vconsole'
// Vue.use(new VConsole())

let base = process.env.NODE_ENV === 'production' ?'https://game.hotplaygames.com':'http://10.0.0.135:8081/api';
Vue.prototype.baseURL = 'https://game.hotplaygames.com';

Vue.use(VueWechatTitle)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
Vue.prototype.$downLoad = downLoad

Vue.use(MetaInfo)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js